<div class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->

  <div class="dash_base">
    <div class="container mt-40">
      <div class="whiteWrap">
        <div class="titleWrap">
          <div class="row w-100">
            <div class="col-sm-12">
              <h4 class="mt-1 d-inline-block">
                {{ isValueTestCompany ? 'My Contacts' : 'My Network' }}
              </h4>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="w-100 client_dashboard">
          <mat-tab-group [selectedIndex]="tabIndex" #tabGroup (selectedTabChange)="tabChange($event)">
            <mat-tab *ngIf="!isValueTestCompany && !isOpScanCompany" aria-label="leadDashboard" label="Lead Dashboard">
              <app-lead-dashboard
                (changeTab)="openClientSheet($event)"
                (changeToMarketingTab)="openMarketingSheet($event)"
              ></app-lead-dashboard>
            </mat-tab>

            <mat-tab
              *ngIf="authorizeService.canView('activeClients')"
              label="{{ isValueTestCompany ? 'Clients' : 'My Clients' }}"
              aria-label="activeClients"
            >
              <app-active-clients [filterToApply]="changeTab"></app-active-clients>
            </mat-tab>

            <!-- <mat-tab
              *ngIf="authorizeService.canView('pastClients') && companyAppConfig?.pastClientConfig?.enabled == true"
              label="Discovered Past Clients"
              aria-label="pastClients"
            >
              <app-past-clients></app-past-clients>
            </mat-tab> -->

            <mat-tab
              *ngIf="authorizeService.canView('partnerDashboard')"
              [label]="isValueTestCompany ? 'Referrals' : 'Partners'"
              aria-label="partners"
            >
              <app-partner-dashboard></app-partner-dashboard>
            </mat-tab>
            <!-- 
            <mat-tab
              *ngIf="authorizeService.canView('referrals') && isValueTestCompany"
              label="Active Referrals"
              aria-label="referrals"
            >
              <app-active-users></app-active-users>
            </mat-tab> -->

            <!-- <mat-tab
              *ngIf="authorizeService.canView('contactLists') && !isOpScanCompany"
              label="Contact Lists"
              aria-label="contactList"
            >
              <app-upload-property-list></app-upload-property-list>
            </mat-tab> -->

            <mat-tab
              *ngIf="authorizeService.canView('agentAnalytics') && companyAppConfig?.agentAnalytics?.isEnabled"
              label="Agent Analytics"
              aria-label="agentAnalytics"
            >
              <app-agent-analytics></app-agent-analytics>
            </mat-tab>

            <!-- <mat-tab
              *ngIf="authorizeService.canView('marketingEffectiveness') && !isValueTestCompany && !isOpScanCompany"
              label="Marketing Effectiveness"
              aria-label="marketingEffectiveness"
            >
              <app-marketing-effectiveness
                *ngIf="isMarketingTrue"
                [filterForMarketingTab]="changeTab"
              ></app-marketing-effectiveness>
            </mat-tab> -->

            <!-- <mat-tab label="Expired Listings" aria-label="ExpiredListings" *ngIf="displayExpiredListings && isAgent"
              ><app-expired-listings></app-expired-listings
            ></mat-tab> -->
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>

<mat-sidenav-container class="client-container">
  <app-client-detail-sheet *ngIf="clientDetailsSheetActive && authorizeService.canView('clientDetailsSheet')">
  </app-client-detail-sheet>
</mat-sidenav-container>

<app-marketing-effectiveness-sheet
  *ngIf="clientMarketingDetailsSheetActive && authorizeService.canView('clientDetailsSheet')"
></app-marketing-effectiveness-sheet>
<app-sent-mail *ngIf="sentMailDataSheetValue"> </app-sent-mail>
<app-create-mail-sheet *ngIf="openCreateMailSheetValue"></app-create-mail-sheet>
<app-save-search-sheet *ngIf="addPropertySearchValue"></app-save-search-sheet>
<app-property-listings *ngIf="openPropertyListingValue"></app-property-listings>
<!-- <app-add-contact-note-sheet *ngIf="openAddContactNoteSheetValue"></app-add-contact-note-sheet> -->
<app-add-expired-listings-notes-sheet
  *ngIf="openAddExpiredListingsNoteSheetValue"
></app-add-expired-listings-notes-sheet>
